<div class="error-page platform-not-supported">
	<header>
		<div class="logo">
			<img src="" />
		</div>
	</header>

	<article text-center>
		<img src="" [alt]="'not-supported.os.title' | translate" />
		<h2>{{ "not-supported.os.title" | translate }}</h2>
		<p>{{ "not-supported.os.message" | translate }}</p>
		<a class="cta" href="/" id="continue-anyway">{{ "not-supported.os.cta" | translate }}</a>
	</article>
</div>
